import { Components, Theme } from '@mui/material/styles';

const containerTheme: Components<Theme>['MuiContainer'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      '&.page-container': {
        padding: theme.spacing(1),
        '&.tablet-full-screen': {
          [theme.breakpoints.up('md')]: {
            width: '100%',
          },
          [theme.breakpoints.up('lg')]: {
            width: '75%',
          },
        },
        [theme.breakpoints.up('md')]: {
          width: '75%',
        },
        '&.greyBg': {
          background: theme.palette.neutralWhite,
          borderWidth: '1px',
          borderStyle: 'solid',
          borderTopWidth: 0,
          minHeight: 'calc(100vh - 64px)',
        },
        '& .main-title': {
          fontSize: '20px',
          color: theme.palette.corporateBlue,
          fontWeight: 'bold',
          background: theme.palette.coldWhite,
          paddingTop: theme.spacing(2),
          paddingBottom: theme.spacing(2),
          textAlign: 'center',
          width: 'calc(100% + 16px)',
          margin: '-8px 0px 8px -8px',
        },
        '& .sub-title': {
          fontSize: '18px',
          color: theme.palette.offGray,
          fontWeight: 'bold',
        },
        // default content size within the page container
        fontSize: '16px',
        color: theme.palette.offGray
      },
    }),
  },
};

export default containerTheme;
